<template>
  <div :class="{ 'login-page': !callFromModal }">
    <div class="login-card">
      <h2>Login</h2>
      <form @submit.prevent="login">
        <div class="mb-3">
          <label for="userId" class="form-label">Phone Number</label>
          <input
            type="text"
            v-model="phoneNumber"
            class="form-control"
            id="userId"
            required
          />
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <input
            type="password"
            v-model="password"
            class="form-control"
            id="password"
            required
          />
        </div>
        <button type="submit" class="btn btn-dark w-100">Login</button>
        <p v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</p>
      </form>
      <p class="mt-3">
        Don't have an account?
        <span class="text-primary" role="button" @click="goToSignup"><u>Sign up now!</u></span>
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { BASE_URL } from "@/globals";
import { usePageMeta } from '@/composables/usePageMeta';

export default {
  name: "LoginCOmponent",
  props: {
    redirectPage: {
      type: Boolean,
      default: true,
    },
    callFromModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      phoneNumber: "",
      password: "",
      errorMessage: "",
    };
  },
  mounted() {
    usePageMeta({
      title: "Login | Sehrish mart",
      description: "Place for quality skincare items",
      image: "",
    });
  },
  methods: {
    async login() {
      try {
        const response = await axios.post(`${BASE_URL}/api/auth/login`, {
          phoneNumber: this.phoneNumber,
          password: this.password,
        });
        const user = {
          phoneNumber: this.phoneNumber,
        };
        const token = response.data.token;
        const passwordResetNeeded = response.data.passwordResetNeeded;
        this.$store.dispatch("login", { user, token, passwordResetNeeded });
        if (this.redirectPage) {
          setTimeout(() => {
            this.$router.push("/");
          }, 500);
        }
        if (this.callFromModal) {
          this.closeModal();
        }
      } catch (error) {
        this.errorMessage = "Login failed. Please check your credentials.";
      }
    },
    goToSignup() {
      this.closeModal()
      this.$router.push('/signup')
    },
    closeModal() {
      this.phoneNumber = "";
      this.password = "";
      this.$emit("closeModal");
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: linear-gradient(135deg, #fdeef1 0%, #f4f5fb 100%);
}

.login-card {
  width: 100%;
  max-width: 560px;
  background: #f7f8fc;
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.08);
}

.login-page .login-card {
  margin: 0 auto;
}

.login-card h2 {
  margin-bottom: 1.5rem;
}
</style>
